import SmoothScroll from 'smooth-scroll'

/**
 * A section that can be scrolled to via URL hash.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalFooter {
  /**
   * Constructs a new GlobalFooter section instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   * @param {Hurdler} options.hurdler - Hurdler instance.
   */
  constructor (options) {
    this.element = options.element
    this.footerLogo = this.element.querySelector('.mm-logo')
    this.scroll = new SmoothScroll()
    this.scrollOptions = {
      speed: 500,
      speedAsDuration: true,
      updateURL: false
    }

    this.footerLogo.addEventListener('click', () => {
      this.scroll.animateScroll(0)
    })

  }
}



// WEBPACK FOOTER //
// ./components/global-footer/index.js